import custom_stripe_billing_ui from './custom-stripe-billing-ui__base.json';
import data_catalog from './data-catalog__base.json';
import data_residency_ui from './data-residency-ui__base.json';
import data_retention_ui from './data-retention-ui__7-day-default.json';
import data_retention_ui1 from './data-retention-ui__aws.json';
import data_retention_ui2 from './data-retention-ui__azure.json';
import data_retention_ui3 from './data-retention-ui__base.json';
import data_retention_ui4 from './data-retention-ui__data-retention-ent.json';
import data_retention_ui5 from './data-retention-ui__data-retention-starter-growth.json';
import data_retention_ui6 from './data-retention-ui__failed-download-credentials.json';
import in_app_email_support from './in-app-email-support__base.json';
import tracking_plans from './tracking-plans__base.json';

export default {
  "project_64c0dc71ffddf09e95b831f3": {
    "base": {...custom_stripe_billing_ui}
  },
  "project_651469d044134222fe8dcbf7": {
    "base": {...data_catalog}
  },
  "project_638523fc63f559803763cec0": {
    "base": {...data_residency_ui}
  },
  "project_63062f550e89ed6a0dfbe143": {
    "7-day-default": {...data_retention_ui},
    "aws": {...data_retention_ui1},
    "azure": {...data_retention_ui2},
    "base": {...data_retention_ui3},
    "data-retention-ent": {...data_retention_ui4},
    "data-retention-starter-growth": {...data_retention_ui5},
    "failed-download-credentials": {...data_retention_ui6}
  },
  "project_630fc9c45c0e7caa5f6fde15": {
    "base": {...in_app_email_support}
  },
  "project_635944cdd3f2b3c9c3a38b2b": {
    "base": {...tracking_plans}
  }
}